namespace $ {

	export class $shm_hitalama_map_access_delivery extends $mol_object {

		@ $mol_mem_key
		static confirmed( [ auth, map, catalog, recipient, self, hash, grant_time, time, uri ]:
			readonly [ $giper_baza_auth, string, string, string, string, string, number, number, string ] ) {
			const body = this.$.$shm_hitalama_map_access_delivery_request.signed([ auth, map, catalog, recipient, self, hash, grant_time, time ])
			const response = this.$.$mol_wire_sync( this.$.$mol_fetch ).response( uri, this.$.$shm_hitalama_map_access_remote.options( body ) )
			// Absent/older servers cannot acknowledge: retain the durable journal.
			if( response.code() !== 200 ) return false
			return response.json() === true
		}

	}

}
